(function () {
	// QA-PERF 2026-09: every media-banner section emits this <script>, so it
	// can execute several times per page. Initialise once, and bind each
	// banner's scroll listener once (section reloads in the editor re-scan).
	if (window.bjMediaBannerInit) return;
	window.bjMediaBannerInit = true;
	const mediaBanner = () => {
		document.querySelectorAll(".media-banner").forEach((block) => {
			if (block.dataset.bjMediaBannerBound) return;
			block.dataset.bjMediaBannerBound = "1";
			let box = block.closest("section");
			let id = box.getAttribute("id");
			block = $(block);

			const stickyEffect = block.data("sticky-effect");

			if (stickyEffect) {
				var normalElement = document.querySelector(`#${id} + .sticky-section`);
				if (normalElement == null) {
					return;
				}

				var isSticky = false;

				window.addEventListener("scroll", function () {
					var stickyTop = box.getBoundingClientRect().top;
					var normalElementTop = normalElement.getBoundingClientRect().top;

					if (stickyTop <= 0 && !isSticky) {
						box.classList.add("sticky-active");
						isSticky = true;
					}

					if (normalElementTop <= 0 && isSticky) {
						box.classList.remove("sticky-active");
						isSticky = false;
					}
				});
			}
		});
	};

	const start = () => {
		mediaBanner();
		document.addEventListener("shopify:section:load", mediaBanner);
	};
	if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
	else start();
})();
